import {useNavigate} from 'react-router-dom';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';

const BasketHeader = () => {
  const navigate = useNavigate();

  return (
    <CustomHeader
      preComponent={() => (
        <div
          className="relative flex items-center justify-center gap-2"
          onClick={() => navigate(-1)}
        >
          <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
          <span className="font-medium">سبد خرید</span>
        </div>
      )}
    />
  );
};

export default BasketHeader;
